export function sm2Review(card, quality) {
  let { easeFactor = 2.5, interval = 1, repetitions = 0 } = card;
  if (quality >= 3) {
    if (repetitions === 0) interval = 1;
    else if (repetitions === 1) interval = 6;
    else interval = Math.round(interval * easeFactor);
    repetitions += 1;
  } else {
    repetitions = 0;
    interval = 1;
  }
  easeFactor = Math.max(1.3, easeFactor + 0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));
  const nextReview = new Date();
  nextReview.setDate(nextReview.getDate() + interval);
  return {
    easeFactor: Math.round(easeFactor * 100) / 100,
    interval,
    repetitions,
    nextReview: nextReview.toISOString().split('T')[0],
    lastReviewed: new Date().toISOString().split('T')[0],
  };
}

export function todayStr() {
  return new Date().toISOString().split('T')[0];
}

export function isDue(card) {
  if (!card.nextReview) return true;
  return card.nextReview <= new Date().toISOString().split('T')[0];
}
